import React, { Component } from 'react';

import {
  Router,
  Switch,
  Route,
  Redirect,
  Link,
  withRouter,
  useParams,
  useRouteMatch
} from "react-router-dom";
//import LocomotiveScroll from 'locomotive-scroll';

import { createBrowserHistory } from "history";

import {getConfig} from './config.js';
import {callAPI} from './Utils.js';

import './App.scss';
import {Header} from './components/Header/Header.js';
import {Footer} from './components/Footer/Footer.js';
import {Home} from './layouts/Home/Home.js';
import {Reels} from './layouts/Reels/Reels.js';
import {Work} from './layouts/Work/Work.js';
import {WorkSingle} from './layouts/WorkSingle/WorkSingle.js';
import {About} from './layouts/About/About.js';
import {Page} from './layouts/Page/Page.js';

const history = createBrowserHistory();


class App extends Component {

  constructor(props) {
    super(props);
    
    let currentSlug = window.location.pathname;
    this.state = { menu: false, menufooter : false, pages : [], projects: [], sitename : '', sitedescription : '', options : false, scrollWidth : 0, loadingBasic: true, loading : true, loadingProgress : 0, finishingLoading : false, slug: currentSlug};

    this.fetchBasicData = this.fetchBasicData.bind(this);
    this.fetchData = this.fetchData.bind(this);
    this.mainScroll = React.createRef();

  }

  componentDidMount() {
    this.fetchBasicData();
    this.fetchData();
    }


  fetchBasicData() {

    let _that = this;
    let _callGral = callAPI(getConfig().server, {});

    Promise.all([_callGral])
      .then(function (values) {
        // Generic data
        _that.setState({sitename : values[0].name, sitedescription : values[0].description, loadingBasic : false});
    });


  }


  fetchData() {

    let _that = this;
    let _callMenu = callAPI(getConfig().server + 'wp/v2/menu', {});
    let _callOptions = callAPI(getConfig().server + 'acf/v2/options', {});
    let _callPages = callAPI(getConfig().server + 'wp/v2/pages', {});
    let _callProjects = callAPI(getConfig().server + 'wp/v2/projects?orderby=menu_order&order=asc&per_page=50', {});
    let _callMenuFooter = callAPI(getConfig().server + 'wp/v2/menufooter', {});

    Promise.all([_callMenu, _callOptions, _callPages, _callProjects, _callMenuFooter])
      .then(function (values) {

        _that.setState({options : values[1].acf});


        // MENU
        let myJSON = values[0];
        let objLength = Object.keys(myJSON).length;

        let menu = {};

        for (let i = 0; i < objLength; i++) {
          let objKey = Object.values(myJSON)[i].menu_order;
          let currentSection = {};
          currentSection.title = Object.values(myJSON)[i].title;
          currentSection.object_id = Object.values(myJSON)[i].object_id;
          currentSection.menu_order = Object.values(myJSON)[i].menu_order;
          currentSection.menu_item_parent = Object.values(myJSON)[i].menu_item_parent;
          currentSection.url = Object.values(myJSON)[i].url;
          currentSection.target = Object.values(myJSON)[i].target;
          menu[objKey] = currentSection;
        }
        _that.setState({menu : menu});

        // MENU FOOTER
        let menuFooterItems = values[4];
        let menuFooterItemsLength = Object.keys(menuFooterItems).length;

        let menuFooter = {};

        for (let i = 0; i < menuFooterItemsLength; i++) {
          let currentItemKey = Object.values(menuFooterItems)[i].menu_order;
          let currentItem = {};
          currentItem.title = Object.values(menuFooterItems)[i].title;
          currentItem.object_id = Object.values(menuFooterItems)[i].object_id;
          currentItem.menu_order = Object.values(menuFooterItems)[i].menu_order;
          currentItem.menu_item_parent = Object.values(menuFooterItems)[i].menu_item_parent;
          currentItem.url = Object.values(menuFooterItems)[i].url;
          currentItem.target = Object.values(menuFooterItems)[i].target;
          menuFooter[currentItemKey] = currentItem;

      }
      _that.setState({menufooter : menuFooter});

      // Pages data
      let pages = values[2];

      let pagesObjLength = Object.keys(pages).length;
      let pagesData = [];
      for (let i = 0; i < pagesObjLength; i++) {
        let objKey = Object.values(pages)[i].id;
        let currentPage = {};

        currentPage.slug = Object.values(pages)[i].slug;
        currentPage.id = objKey;
        currentPage.title = Object.values(pages)[i].title.rendered;
        currentPage.content = Object.values(pages)[i].content.rendered;
        currentPage.url = Object.values(pages)[i].link;
        currentPage.custom_fields = Object.values(pages)[i].acf;
        currentPage.featured_image_url = Object.values(pages)[i].featured_image_url;

        pagesData[currentPage.slug] = currentPage;

      }

      _that.setState({pages : pagesData});

      // Projects
      _that.setState({projects : values[3]});

      setInterval(() => {
        if (_that.state.loadingProgress < 100) {
          _that.setState({loadingProgress: _that.state.loadingProgress+10});
        }
      }, 100);

      setTimeout(() => {
        _that.setState({finishingLoading : true});
      }, 1200);

      setTimeout(() => {
        _that.setState({loading : false});
      }, 2200);

    });


  }

  render() {
    let loadingBasicClass = (this.state.loadingBasic) ? 'basicloading' : '';
    let loadingClass = (this.state.loading) ? 'loading' : '';
    let finishingClass = (this.state.finishingLoading) ? 'finishing' : '';

    const WrappedFooter = withRouter(Footer);
    return (
      <Router history={history}>
        <div className={`site ${loadingBasicClass} ${loadingClass}`}>
          <div className="site__loading">
            <div className="site__loading__progress">
              <div className={`site__loading__progress__bar ${finishingClass}`} style={{width: this.state.loadingProgress + '%'}}></div>
            </div>
            <div className="site__loading__inner">
              <h1 className="site__loading__title">
                <svg width="162px" height="19px" viewBox="0 0 162 19" version="1.1">
                    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                        <g fill="#ffffff">
                            <path d="M141.7332,4.7794 C143.3882,4.7794 144.7572,5.1664 145.8152,5.9674 C146.8752,6.7684 147.4692,7.8024 147.5982,9.1194 L145.3252,9.1194 C144.8852,7.4924 143.6452,6.6914 141.6562,6.6914 C140.2352,6.6914 139.1502,7.2074 138.3752,8.2154 C137.6252,9.2234 137.2382,10.4374 137.2382,11.8844 C137.2382,13.2024 137.6252,14.3644 138.3752,15.3464 C139.1252,16.3274 140.1832,16.8194 141.5012,16.8194 C143.7492,16.8194 145.0662,16.0444 145.4792,14.1054 L147.7272,14.1054 C147.0302,17.4384 144.9892,18.7564 141.4502,18.7564 C139.4612,18.7564 137.8582,18.1364 136.6952,16.8704 C135.5332,15.6044 134.9642,13.9254 134.9642,11.8844 C134.9642,9.8434 135.5852,8.1634 136.8252,6.8204 C138.0912,5.4514 139.7192,4.7794 141.7332,4.7794 Z M155.4126,4.7798 C157.4526,4.7798 159.0806,5.4518 160.2426,6.7688 C161.4056,8.0868 161.9996,9.7398 161.9996,11.7808 C161.9996,13.7958 161.4056,15.4758 160.2426,16.7928 C159.0806,18.1108 157.4526,18.7568 155.4126,18.7568 C153.3706,18.7568 151.7436,18.1108 150.5806,16.7928 C149.4176,15.4758 148.8236,13.7958 148.8236,11.7808 C148.8236,9.7398 149.4176,8.0868 150.5806,6.7688 C151.7436,5.4518 153.3706,4.7798 155.4126,4.7798 Z M38.62,4.7794 C40.274,4.7794 41.644,5.1664 42.703,5.9674 C43.762,6.7684 44.357,7.8024 44.485,9.1194 L42.211,9.1194 C41.773,7.4924 40.531,6.6914 38.542,6.6914 C37.122,6.6914 36.037,7.2074 35.262,8.2154 C34.513,9.2234 34.125,10.4374 34.125,11.8844 C34.125,13.2024 34.513,14.3644 35.262,15.3464 C36.011,16.3274 37.07,16.8194 38.388,16.8194 C40.636,16.8194 41.953,16.0444 42.367,14.1054 L44.614,14.1054 C43.917,17.4384 41.875,18.7564 38.336,18.7564 C36.347,18.7564 34.745,18.1364 33.582,16.8704 C32.42,15.6044 31.852,13.9254 31.852,11.8844 C31.852,9.8434 32.472,8.1634 33.712,6.8204 C34.978,5.4514 36.605,4.7794 38.62,4.7794 Z M67.0894,4.7798 C69.1294,4.7798 70.7574,5.4518 71.9194,6.7688 C73.0824,8.0868 73.6764,9.7398 73.6764,11.7808 C73.6764,13.7958 73.0824,15.4758 71.9194,16.7928 C70.7574,18.1108 69.1294,18.7568 67.0894,18.7568 C65.0474,18.7568 63.4204,18.1108 62.2574,16.7928 C61.0944,15.4758 60.5004,13.7958 60.5004,11.7808 C60.5004,9.7398 61.0944,8.0868 62.2574,6.7688 C63.4204,5.4518 65.0474,4.7798 67.0894,4.7798 Z M94.9825,4.78 C99.8135,4.78 101.3635,9.197 101.2095,12.452 L90.6415,12.452 C90.8745,15.372 92.3475,16.819 95.0605,16.819 C96.9465,16.819 98.3155,15.94 98.7035,14.21 L100.9765,14.21 C100.3815,17.129 98.1605,18.757 95.0605,18.757 C90.8235,18.757 88.4465,15.966 88.3165,11.729 C88.3165,9.74 88.9615,8.087 90.2285,6.769 C91.4945,5.451 93.0955,4.78 94.9825,4.78 Z M127.4544,4.7798 C129.1334,4.7798 130.3994,5.0638 131.2774,5.6058 C132.1814,6.1478 132.7244,7.1818 132.9304,8.7318 L130.7874,8.7318 C130.3994,7.0788 129.3394,6.6658 127.6084,6.6658 C126.0854,6.6658 124.7934,7.2078 124.7934,8.4478 C124.7934,9.3008 125.3354,9.7658 126.2394,10.0758 L127.0924,10.3338 L128.1264,10.5408 C128.5894,10.6178 128.9254,10.6958 129.1594,10.7478 C130.4254,11.0318 131.2254,11.3158 132.1294,11.8588 C133.0604,12.4008 133.5244,13.3308 133.5244,14.5458 C133.5244,15.5538 133.2144,16.3788 132.5694,17.0508 C131.3294,18.3688 129.5974,18.7568 127.6084,18.7568 C126.0584,18.7568 124.7674,18.4468 123.7334,17.8008 C122.7004,17.1548 122.1314,16.0438 122.0284,14.5198 L124.2754,14.5198 C124.4054,16.0958 125.5684,16.8708 127.7124,16.8708 C128.6424,16.8708 129.4434,16.7148 130.1404,16.4048 C130.8384,16.0958 131.2004,15.5788 131.2004,14.8298 C131.2004,14.1318 130.8124,13.6148 130.3994,13.3048 C130.2174,13.1498 129.9084,12.9958 129.4954,12.8658 C129.0824,12.7368 128.7464,12.6338 128.4624,12.5818 C128.2034,12.5038 127.8164,12.4268 127.2724,12.3238 C126.0584,12.0908 125.5924,11.9878 124.5864,11.5998 C123.2424,11.0318 122.5714,10.2568 122.4674,8.5778 C122.4674,7.3368 122.9584,6.4068 123.9654,5.7618 C124.9734,5.1158 126.1364,4.7798 127.4544,4.7798 Z M114.4597,4.7793 C116.3977,4.7793 117.8697,5.3473 118.5937,5.9933 C118.9817,6.3293 119.2657,6.7173 119.4727,7.2073 C119.9107,8.1383 119.9627,8.7323 119.9627,9.4813 L119.9627,16.6383 C119.9627,17.3873 120.0397,17.9813 120.1697,18.4463 L117.8447,18.4463 C117.7667,17.9813 117.7417,16.9993 117.7417,15.4753 L117.7147,15.4753 C117.3017,17.6203 115.5977,18.7563 113.0377,18.7563 C108.9567,18.7563 108.1817,16.6123 108.1817,14.9063 C108.1817,13.2273 109.0607,12.0393 110.4037,11.5223 C111.1007,11.2643 111.7467,11.0833 112.3927,10.9543 C113.0377,10.8253 113.7097,10.7223 114.4337,10.6433 C115.1837,10.5663 115.6747,10.4893 115.9077,10.4123 C117.4307,9.9723 117.6377,9.6363 117.6377,8.6283 C117.6377,7.3893 116.5007,6.6913 114.5117,6.6913 C113.1677,6.6913 112.2647,7.0793 111.8757,7.7253 C111.5407,8.3443 111.5147,8.5253 111.4367,9.0163 L109.1117,9.0163 C109.2147,8.1643 109.3697,7.5433 109.6037,7.1043 C110.4037,5.5543 112.0317,4.7793 114.4597,4.7793 Z M24.0242,4.7793 C25.9622,4.7793 27.4342,5.3473 28.1582,5.9933 C28.5462,6.3293 28.8302,6.7173 29.0362,7.2073 C29.4762,8.1383 29.5282,8.7323 29.5282,9.4813 L29.5282,16.6383 C29.5282,17.3873 29.6052,17.9813 29.7342,18.4463 L27.4092,18.4463 C27.3312,17.9813 27.3062,16.9993 27.3062,15.4753 L27.2802,15.4753 C26.8672,17.6203 25.1612,18.7563 22.6042,18.7563 C18.5212,18.7563 17.7462,16.6123 17.7462,14.9063 C17.7462,13.2273 18.6252,12.0393 19.9682,11.5223 C20.6662,11.2643 21.3112,11.0833 21.9582,10.9543 C22.6042,10.8253 23.2752,10.7223 23.9992,10.6433 C24.7482,10.5663 25.2392,10.4893 25.4722,10.4123 C26.9952,9.9723 27.2032,9.6363 27.2032,8.6283 C27.2032,7.3893 26.0652,6.6913 24.0762,6.6913 C22.7322,6.6913 21.8282,7.0793 21.4402,7.7253 C21.1042,8.3443 21.0792,8.5253 21.0022,9.0163 L18.6772,9.0163 C18.7792,8.1643 18.9352,7.5433 19.1672,7.1043 C19.9682,5.5543 21.5972,4.7793 24.0242,4.7793 Z M75.7904,-0.0002 L81.0874,15.9928 L81.1374,15.9928 L86.4864,-0.0002 L89.0694,-0.0002 L82.6634,18.4208 L79.5624,18.4468 L73.2064,-0.0002 L75.7904,-0.0002 Z M48.9529,-0.0006 L48.9529,7.8534 C49.5999,5.7874 51.2789,4.7794 53.2689,4.7794 C56.6779,4.7794 58.3829,6.6654 58.3829,9.6624 L58.3829,18.4464 L56.0579,18.4464 L56.0579,9.8954 C56.0579,7.5434 54.9469,6.7174 52.9579,6.7174 C50.6839,6.7174 49.2119,7.8534 49.0049,10.2304 L49.0049,18.4464 L46.6799,18.4464 L46.6799,-0.0006 L48.9529,-0.0006 Z M105.909,-0.0005 L105.909,18.4465 L103.584,18.4465 L103.584,-0.0005 L105.909,-0.0005 Z M2.6091,-0.0004 L12.7371,14.9586 L12.7881,14.9586 L12.7881,-0.0004 L15.1141,-0.0004 L15.1141,18.4466 L12.4271,18.4466 L2.3761,3.6426 L2.3261,3.6426 L2.3261,18.4466 L0.0001,18.4466 L0.0001,-0.0004 L2.6091,-0.0004 Z M27.2032,10.1013 C26.9702,11.2643 25.9622,11.7033 23.5082,12.1943 C21.1312,12.6333 20.1492,13.2023 20.1492,14.8553 C20.1492,16.0953 21.1822,16.9483 22.8622,16.9483 C25.7292,16.9483 27.2032,15.6303 27.2032,12.2463 L27.2032,10.1013 Z M117.6377,10.1013 C117.4057,11.2643 116.3977,11.7033 113.9437,12.1943 C111.5667,12.6333 110.5847,13.2023 110.5847,14.8553 C110.5847,16.0953 111.6177,16.9483 113.2967,16.9483 C116.1647,16.9483 117.6377,15.6303 117.6377,12.2463 L117.6377,10.1013 Z M155.4126,6.6908 C154.1966,6.6908 153.1886,7.1558 152.3636,8.0608 C151.5616,8.9648 151.1486,10.2048 151.1486,11.7808 C151.1486,13.3308 151.5616,14.5708 152.3636,15.4758 C153.1886,16.3788 154.1966,16.8188 155.4126,16.8188 C156.6256,16.8188 157.6336,16.3788 158.4346,15.4758 C159.2606,14.5708 159.6746,13.3308 159.6746,11.7808 C159.6746,10.2048 159.2606,8.9648 158.4346,8.0608 C157.6336,7.1558 156.6256,6.6908 155.4126,6.6908 Z M67.0894,6.6908 C65.8734,6.6908 64.8654,7.1558 64.0404,8.0608 C63.2384,8.9648 62.8254,10.2048 62.8254,11.7808 C62.8254,13.3308 63.2384,14.5708 64.0404,15.4758 C64.8654,16.3788 65.8734,16.8188 67.0894,16.8188 C68.3024,16.8188 69.3104,16.3788 70.1114,15.4758 C70.9374,14.5708 71.3514,13.3308 71.3514,11.7808 C71.3514,10.2048 70.9374,8.9648 70.1114,8.0608 C69.3104,7.1558 68.3024,6.6908 67.0894,6.6908 Z M94.9825,6.691 C92.8125,6.691 91.1325,8.216 90.7195,10.489 L98.8575,10.489 C98.7285,8.319 97.1775,6.691 94.9825,6.691 Z"></path>
                        </g>
                    </g>
                </svg>
                <span className="screen-reader-text">{this.state.sitename}</span>
              </h1>
              <h2 className="site__loading__description" dangerouslySetInnerHTML={{__html: this.state.sitedescription}} />
            </div>
          </div>
          <Header currentScrollWidth={this.state.scrollWidth} menu={this.state.menu} sitename={this.state.sitename} sitedescription={this.state.sitedescription} options={this.state.options} />
          <div className="site__scrollable" ref={this.mainScroll}>
            <div className="site__main" >
            {!this.state.loading &&

              <Switch>

                <Route exact path="/en">
                  <Home content={this.state.pages['home']} projects={this.state.projects} />
                </Route>
                <Route exact path="/">
                  <Redirect
                    to={{
                      pathname: "/en"
                    }}
                  />
                </Route>
                <Route exact path="/en/about">
                  <About content={this.state.pages['about']} />
                </Route>
                <Route exact path="/en/profile">
                  <About content={this.state.pages['profile']} />
                </Route>
                <Route exact path="/en/reel/">
                  <Reels content={this.state.pages['reel']} />
                </Route>
                <Route path="/en/work">
                  <WorkDistributor content={this.state.pages['work']} projects={this.state.projects} />
                </Route>
                <Route path={`/en/:slug`}>
                  <PageDistributor pages={this.state.pages} />

                </Route>
              </Switch>
                }
            </div>
            <WrappedFooter currentSlug={this.state.slug} sitename={this.state.sitename} options={this.state.options} menu={this.state.menufooter} />
          </div>

        </div>

      </Router>
    )

  }
}

export default App;

function WorkDistributor(props) {
  let { path, url } = useRouteMatch();
  return (
    <div>
    <Switch>
      <Route exact path={path}>
        <Work url={url} path={path} content={props.content} projects={props.projects} />
      </Route>
      <Route path={`${path}/:slug`}>
        <WorkSingleDistributor projects={props.projects} />
      </Route>
    </Switch>
    </div>
  )
}


function WorkSingleDistributor(props) {
  // The <Route> that rendered this component has a
  // path of `/topics/:topicId`. The `:topicId` portion
  // of the URL indicates a placeholder that we can
  // get from `useParams()`.
  let { slug } = useParams();

  return (
    <WorkSingle projects={props.projects} currentSlug={slug} />
  );
}

function PageDistributor(props) {
  let { slug } = useParams();
  if (props.pages[slug]) {
    return (
      <Page content={props.pages[slug]} />
    );
  } else {
    return (
      <div className="error404">NOT FOUND</div>
    );
  }
}
